import { logE } from "@blacknut/logging/dist";
import { Observable, ReplaySubject } from "rxjs";

const replaceURLDev = (s: string) => {
  if (process.env.NODE_ENV === "development") {
    const re = /(staging|prod|dev)-images\.blacknut\.(net|com)\/(.*)/;
    const matches = s.match(re);
    if (matches) {
      return `https://blacknut-${matches[1]}-images.b-cdn.net/${matches[3]}`;
    }
  }
  return s;
};

//blacknut-staging-images.b-cdn.net/67b82d50e633a135de26a230.svg
const TAG = "SVGDownloader";

class SVGDownloader {
  private pending: Map<string, Observable<string | undefined>> = new Map();
  download(url: string) {
    if (this.pending.has(url)) {
      return this.pending.get(url)!;
    } else {
      const subject = new ReplaySubject<string | undefined>(1);
      const observable = subject.asObservable();
      this.pending.set(url, subject);
      fetch(replaceURLDev(url))
        .then((response) => {
          if (response.ok) {
            return response.text();
          }
          return undefined;
        })
        .then((text) => {
          console.log("fetched");
          subject.next(text);
        })
        .catch((e) => {
          logE(TAG, "Caught error downloading svg from url %o:  %o", url, e);
        });
      return observable;
    }
  }
}

const svgDownloader = new SVGDownloader();
export default svgDownloader;
